import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { CmsService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { PermissionsConstants } from 'src/app/service/myaccount/my-account-permission.constants';
import { MyAccountPermissionService } from 'src/app/service/myaccount/my-account-permission.service';
import { StorageService } from 'src/app/service/storage/storage.service';

@Component({
  selector: 'app-srp-toggle',
  templateUrl: './srp-toggle.component.html',
  styleUrls: ['./srp-toggle.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class SrpToggleComponent implements OnInit, OnDestroy {
  srpToggleValue = false;
  disabled = false;
  currentPageSubscription$: Subscription;
  userPermissionSubscription$: Subscription;
  activeCountry$: Observable<string> = this.countryService.getActive();
  activeCountry = this.pipeAsync.transform(this.activeCountry$);
  srpDisplayed: boolean;
  storeFrontPermissionsSubscription$: Subscription;
  snahCountriesSubscription$: Subscription;

  constructor(
    private componentService: ComponentService,
    private cmsService: CmsService,
    private cdr: ChangeDetectorRef,
    private countryService: ShimanoCountryService,
    private pipeAsync: AsyncPipe,
    private storageService: StorageService,
    private myAccountPermissionService: MyAccountPermissionService
  ) {}

  ngOnInit() {
    this.getSrpToggleValue();
    this.currentPageSubscription$ = this.cmsService.getCurrentPage().subscribe((currentPageDetails) => {
      if (currentPageDetails && currentPageDetails.template === 'ShimanoCheckoutSummaryPageTemplate') {
        this.disabled = true;
        this.srpToggleValue = false;
      } else {
        this.disabled = false;
        this.srpToggleValue = this.storageService.getLocalStorageItem('showSrp') === 'true';
      }
      this.cdr.detectChanges();
    });

    this.storeFrontPermissionsSubscription$ = this.myAccountPermissionService.currentUserPermissions$
      .pipe(
        map((permissions) => permissions?.includes(PermissionsConstants.VIEW_WHOLESALE_PRICE)),
        filter((viewWholesalePrice) => viewWholesalePrice !== undefined), // to not emit for countries w/o permissions
        distinctUntilChanged()
      )
      .subscribe((viewWholesalePrice) => {
        if (viewWholesalePrice) {
          this.srpDisplayed = true;
          const localStorageShowSrpValue: boolean = JSON.parse(this.storageService.getLocalStorageItem('showSrp'));
          this.componentService.setSrpToggle(localStorageShowSrpValue);
        } else {
          this.srpDisplayed = false;
          this.storageService.setLocalStorageitem('showSrp', 'true');
          this.componentService.setSrpToggle(true);
        }
        this.cdr.detectChanges();
      });
  }

  getSrpToggleValue() {
    this.srpToggleValue = this.storageService.getLocalStorageItem('showSrp') === 'true';
    this.componentService.setSrpToggle(this.srpToggleValue);
  }

  onChangeSrpToggle(event: MatSlideToggleChange) {
    this.srpToggleValue = event.checked;
    this.storageService.setLocalStorageitem('showSrp', event.checked ? 'true' : 'false');
    this.componentService.setSrpToggle(event.checked);
  }

  checkoutID(): string {
    return this.activeCountry === 'au' || this.activeCountry === 'nz' ? 'Checkout-' + this.activeCountry : 'Checkout';
  }

  ngOnDestroy() {
    if (this.currentPageSubscription$) {
      this.currentPageSubscription$.unsubscribe();
    }
    if (this.storeFrontPermissionsSubscription$) {
      this.storeFrontPermissionsSubscription$.unsubscribe();
    }
    if (this.snahCountriesSubscription$) {
      this.snahCountriesSubscription$.unsubscribe();
    }
  }
}
